GameView    = require "views/base/game"
SlideView = require("views/slide")
Prefix = require("lib/prefix")
{ DraggyView }  = require("views/components/draggy")

class DragToMatchView extends GameView
  template: require("./template")

  events:
    "iostap .btn-done": "endGame"

  serialize: ->
    data = super

    data.list =
      for item, i in data.list when item.image and item.name
        _.extend { id: i }, item

    data.list   = _.shuffle(data.list)

    data.names  =
      _.chain(data.list)
        .shuffle()
        .filter(({name}, i, arr) -> _.pluck(arr, "name").indexOf(name) is i)
        .value()

    isLong = false
    for item in data.list
      if item.nameType is "text" or item.nameType is "" or not item.nameType
        isLong = isLong or (item.name or "").length > 32
      if item.imageType is "text" or item.imageType is ""
        isLong = isLong or (item.image or "").length > 32
      continue if isLong

    data.isLong = isLong

    data

  onRefresh: ->
    @beforeShow()
    super

  beforeShow: ->
    @setHeight()

  show: ->
    super
    @listenTo this, "resize", @onResize
    @droppies = @getElements(".droppy")

    @draggies =
      for el in @findAll(".draggy")
        draggy = new DraggyView({el})
        draggy.id = el.dataset.id
        @listenTo draggy, "drag", @onDrag
        @listenTo draggy, "drop", @onDrop
        draggy

    @enterGame()

  setHeight: ->
    outer = @findOne ".drag-to-match-outer"
    title = @findOne ".title-wrapper"
    inner = @findOne ".drag-to-match-inner"

    inner.style.height = outer.offsetHeight - title.offsetHeight + "px"

  onDrag: (draggy, isInitialDrag) ->
    @droppies   = @getElements(".droppy", @droppies) if isInitialDrag
    activeIndex = draggy.closest(_.pluck(@droppies, "bounds"))

    for droppy, i in @droppies
      droppy.el.classList.toggle("active", i is activeIndex)
      droppy.isActive = i is activeIndex

    if isInitialDrag
      draggy.el.classList.remove("fade")
      droppy   = @droppies[activeIndex]
      contains = _.without(droppy?.contains, draggy.id)
      if contains.length
        @getDraggyFromId(_.last(contains)).el.classList.remove("fade")
      else if droppy
        droppy.el.classList.remove("contains")

    @transform draggy.el,
      x: draggy.x
      y: draggy.y
      scale: 1.25
      transition: if isInitialDrag then "all 300ms" else "none"

  onDrop: (draggy) ->
    {left, top, width, height} = draggy.offset

    droppy = (droppy for droppy in @droppies when droppy.isActive)[0]

    x = y = 0

    if droppy
      {bounds} = droppy
      x = Math.round bounds.left + bounds.width / 2 - left - width / 2
      y = Math.round bounds.top + bounds.height / 2 - top - height / 2
    else
      draggy.isPositioned = false

    if @options.data.reject and
       droppy?.el.dataset.name isnt draggy.el.dataset.name
      droppy?.isActive = false
      x = y = 0

      if droppy
        droppy.el.classList.add("incorrect")
        window.setTimeout (-> droppy.el.classList.remove("incorrect")), 400

    if draggy.x isnt x or draggy.y isnt y
      draggy.reset({x, y})
    else
      @transform draggy.el,
        x: draggy.x
        y: draggy.y
        transition: "all 300ms"

      @checkAnswer(draggy)

    @setState(if @isTouched() then "touched" else "prompt")

  onResize: (e) ->
    @setHeight()
    for droppy in @droppies or []
      for id in droppy.contains or []
        draggy = @getDraggyFromId(id)
        # remove transition while recalc to avoid janky experience
        @transition draggy.el, "none"
        draggy.getOffset()

        # re-calculate x-axis and y-axis
        bounds = droppy.el.getBoundingClientRect()
        { left, top, width, height } = draggy.offset
        x = Math.round bounds.left + bounds.width / 2 - left - width / 2
        y = Math.round bounds.top + bounds.height / 2 - top - height / 2
        
        #  set draggy position and transform
        draggy.setPosition({ x, y })
        @transform draggy.el, {
          x: x
          y: y
        } 

  getDraggyFromId: (id) ->
    _.findWhere(@draggies, { id })

  getElements: (selector, original) ->
    if original
      for {el, contains} in original
        { el, contains, bounds: el.getBoundingClientRect() }
    else
      for el, i in @findAll(selector)
        el: el
        bounds: el.getBoundingClientRect()
        contains: []

  resetDraggy: (draggy) ->
    draggy.reset()
    draggy.el.classList.remove("is-positioned")
    draggy.isPositioned = false

  checkAnswer: (draggy) ->
    for droppy in @droppies
      droppy.el.classList.remove("active")
      doesContain = _.include(droppy.contains, draggy.id)

      if droppy.isActive
        draggy.el.classList.add("is-positioned")
        draggy.isPositioned = true

        if droppy.contains.length > 0 and not doesContain and @isOnlyUnique()
          droppy.isActive = false
          @resetDraggy @getDraggyFromId(droppy.contains[0])

        droppy.contains =
          _.uniq(droppy.contains.concat(draggy.id))

      else if doesContain
        droppy.contains = _.without(droppy.contains, draggy.id)

      for id, i in droppy.contains
        d = @getDraggyFromId(id)
        d.el.classList.toggle("fade", i isnt droppy.contains.length - 1)

      droppy.el.classList.toggle("contains", droppy.contains.length > 0)

  isTouched: ->
    touchedDraggies = (draggy for draggy in @draggies when draggy.isPositioned)
    touchedDraggies.length is @options.data.list.length

  isCorrect: ->
    correctDraggies =
      droppy for droppy in @droppies when (
        _.filter(droppy.contains, (id) =>
          droppy.el.dataset.name is @getDraggyFromId(id).el.dataset.name
        ).length is droppy.contains.length
      )

    correctDraggies.length is @droppies.length

  showAnswer: ->
    for droppy in @droppies
      droppyCorrect = true
      for id in droppy.contains
        draggy    = @getDraggyFromId(id)
        isCorrect = droppy.el.dataset.name is draggy.el.dataset.name
        draggy.el.classList.toggle "incorrect", not isCorrect
        droppyCorrect = false if not isCorrect

      droppy.el.classList.toggle "correct", droppyCorrect

  isOnlyUnique: ->
    _.chain(@options.data.list)
      .pluck("name")
      .uniq()
      .value().length is @options.data.list.length

  answerDetails: ->
    questions = @options.metadata?.questions or []
    return [] unless questions.length > 0
    details = []

    draggiesByContentDict = _.indexBy @draggies, (d) ->
      if d.el.children[0].dataset.content? then d.el.children[0].dataset.content else d.el.innerText.toLowerCase()

    for q in questions
      if selectedDraggy = draggiesByContentDict[q.question.content.toLowerCase()]
        selectedDroppy = _.find @droppies, (droppy) ->
          selectedDraggy.el.dataset.id in droppy.contains
        details.push
          question: q.question
          answer: _.find q.answers, (a) ->
            a.content is selectedDroppy.el.dataset.name
    details

  endGame: ->
    super

    @submit()

module.exports = DragToMatchView
